<template>
    <div>
        <table class="table table-sm" v-if="receita && receita.items">
            <tr v-if="get_info_receita(receita).in_peso">
                <div class="alert alert-secondary small mb-1 py-1 px-2 d-flex justify-content-between">
                    <div>
                        <span class="mr-3" v-if="get_info_receita(receita).in_peso">Peso: {{ get_info_receita(receita).in_peso }} kg</span>
                        <span class="mr-3" v-if="get_info_receita(receita).in_altura">Altura: {{ $util.formatMoeda(get_info_receita(receita).in_altura) }} m</span>
                        <span class="mr-3" v-if="get_info_receita(receita).in_altura && get_info_receita(receita).in_peso">SC: {{ $util.formatMoeda($util.calc_sup_corp(get_info_receita(receita).in_peso, get_info_receita(receita).in_altura)) }} m2</span>
                        <span class="mr-3" v-if="get_info_receita(receita).dc_creatinina">Creatinina: {{ $util.formatMoeda(get_info_receita(receita).dc_creatinina) }} mg/dL</span>
                    </div>
                    <div>
                        <span class="text-muted" v-if="( get_info_receita(receita).in_altura || get_info_receita(receita).in_peso ) && get_info_receita(receita).dt_pesagem" title="Aferição">{{ $util.getFormatDate(get_info_receita(receita).dt_pesagem) }}</span>
                    </div>
                </div>
            </tr>

            <template v-for="(medics, grupo, imx) in agrupar_receita(receita.items)">
                <tr :key="'G' + imx" v-if="grupo && grupo != 'null'">
                    <td class="table-info">
                        <strong>{{ grupo }}</strong>
                        <i class="fa-solid fa-circle-dot text-warning ml-2" title="Próxima Marcação" v-if="grupo && receita.protocolo && receita.protocolo.infusao && receita.protocolo.infusao.proxima_marcacao && receita.protocolo.infusao.proxima_marcacao.st_regiao && grupo == receita.protocolo.infusao.proxima_marcacao.st_regiao"></i>
                    </td>
                </tr>
                <template v-for="(medic, immx) in medics">
                    <tr :key="'P' + imx + 'I' + immx" v-if="true">
                        <td>
                            <div class="row">
                                <div class="col col-12 col-md-1">
                                    <az-audit-log-button model="receitaMedicamento" :id="medic.id_receita_medicamento" sizing="sm" class="ml-3" />
                                </div>
                                <div class="col col-12 col-md-11">
                                    <div v-if="medic.diluidos && medic.diluidos.length">
                                        <div v-for="(diluido, idx) in medic.diluidos" :key="idx" class="mb-2">
                                            <table class="table table-sm table-borderless p-0 m-0">
                                                <tr>
                                                    <td class="py-0" width="1%"><i class="fa fa-plus fa-fw mr-1" aria-hidden="true"></i></td>
                                                    <td class="py-0">{{ diluido.item.st_medicamento }}</td>
                                                </tr>
                                                <tr v-if="diluido.quantidade">
                                                    <td class="py-0"></td>
                                                    <td class="text-muted py-0">{{ diluido.quantidade }}
                                                        <span v-if="diluido.qtd_calc">
                                                            <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                            <strong>
                                                                {{ diluido.qtd_calc }}
                                                            </strong>
                                                        </span>
                                                    </td>
                                                </tr>
                                                <tr v-if="diluido.st_posologia">
                                                    <td class="py-0"></td>
                                                    <td class="py-0 text-muted">{{ diluido.st_posologia }}</td>
                                                </tr>
                                                <tr v-if="medic.st_observacoes">
                                                    <td class="py-0"></td>
                                                    <td class="py-0 text-muted">{{ medic.st_observacoes }}</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                    <div :class="( medic.diluidos && medic.diluidos.length ) ? 'small' : ''">
                                        <div>{{ ( medic.diluidos && medic.diluidos.length ) ? 'diluído em ' : '' }} {{ medic.item.st_medicamento }}</div>
                                        <div class="text-muted">{{ medic.quantidade }}
                                            <span v-if="medic.qtd_calc">
                                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                {{ medic.qtd_calc }}
                                            </span>
                                        </div>
                                        <div class="text-muted">{{ medic.st_posologia }}</div>
                                        <div class="small text-muted" v-if="medic.st_observacoes">{{ medic.st_observacoes }}</div>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </template>
            </template>

            <!-- Edição -->
             <tr v-if="is_medico">
                <td class="d-flex justify-content-between">
                    <div>
                        <template v-if="!tem_sessao && receita.protocolo && receita.protocolo.infusao && receita.protocolo.infusao.proxima_marcacao && !receita.protocolo.infusao.proxima_marcacao.id_atendimento">
                            <button type="button" class="btn btn-primary mr-1" @click="editar_prescricao(receita, 'P')">
                                Editar Protocolo
                            </button>

                            <button type="button" class="btn btn-info" @click="editar_prescricao(receita, 'S', receita.protocolo.infusao.proxima_marcacao.id_marcacao)">
                                Editar Sessão
                            </button>
                        </template>

                        <template v-else>
                            <button type="button" class="btn btn-primary" @click="editar_prescricao(receita)" :disabled="is_receita_de_sessao(receita) && !receita.id_marcacao_edicao">
                                Editar {{ is_receita_de_sessao(receita) ? 'Sessão' : 'Protocolo' }}
                            </button>
                        </template>
                    </div>
                    <div>
                        <div v-if="receita.id_receita_editada" class="text-right">
                            <span class="badge badge-primary">
                                Editada ({{ receita.id_receita_editada }})
                            </span>
                        </div>

                        <span v-if="receita.protocolo" class="text-right">
                            <span class="badge badge-dark" v-if="receita.editada && receita.editada.id_marcacao_edicao">
                                Prescrição da Sessão (M{{ receita.editada.id_marcacao_edicao }})
                            </span>
                            <span class="badge badge-dark" v-else>
                                Prescrição do Protocolo
                            </span>

                            <div v-if="receita.protocolo.infusao" class="small text-muted">{{ receita.protocolo.infusao.id_infusao }}</div>
                        </span>

                        <span v-else-if="is_receita_de_sessao(receita)" class="text-right">
                            <span class="badge badge-warning">
                                Prescrição da Sessão
                            </span>
                            <div class="small text-muted" v-if="receita.anamnese">
                                {{ receita.anamnese.atendimento_procedimento.atendimento.marcacao.infusao.id_infusao }}
                            </div>
                        </span>
                    </div>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import _ from 'lodash';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';

export default {
    props: ['receita', 'is_medico', 'tem_sessao', 'is_sessao', 'receita_base'],

    components: {
        AzAuditLogButton,
    },

    methods: {
        is_receita_de_sessao (receita) { 
            if ( this.is_sessao ) { 
                return true; 
            }

            if ( receita && receita.id_marcacao_edicao ) { 
                return true; 
            }

            return ( receita
                && receita.anamnese 
                && receita.anamnese.atendimento_procedimento 
                && receita.anamnese.atendimento_procedimento.atendimento.marcacao 
                && receita.anamnese.atendimento_procedimento.atendimento.marcacao.infusao ) ? true : false; 
        },

        agrupar_receita(lista) { 
            return _.groupBy(lista, 'st_agrupa');
        },

        get_info_receita (receita) { 
            return ( receita && receita.editada ) ? receita.editada : receita; 
        },

        editar_prescricao (receita, tipo_edicao = '', id_marcacao = null) { 
            this.$parent.editar_prescricao(receita, tipo_edicao, id_marcacao, this.receita_base);
        },
    },
}
</script>
